module.exports = __webpack_public_path__ + "img/wall.e114e781.jpg";